import React from 'react';

const TitleText = ({data}) => {
	return (
		<section className="title-text">
			<div className="container">
				<div className="small-12">
					<h2>{data.title}</h2>
					<p className="blue">{data.description}</p>
				</div>
			</div>
		</section>
	)
};

export default TitleText;



// WEBPACK FOOTER //
// ./src/components/title-text/index.jsx